<script lang="ts" setup>
  import AsteriskText from '~/components/shared/Forms/AsteriskText.vue';

  const props = defineProps<{
    value: string | null;
    labelText: string;
    name: string;
    stateKey: string;
    placeholder?: string;
    rules?: any;
    labelClass?: string;
    inputClass?: string;
    isCompulsory?: boolean;
    isDisabled?: boolean;
    type?: string;
    labelCol?: object;
  }>();

  const localValue = ref<string | null>(props.value);

  const emit = defineEmits(['update:value']);

  watch(
    () => props.value,
    newValue => {
      localValue.value = newValue;
    }
  );

  watch(
    () => localValue.value,
    newValue => {
      emit('update:value', newValue, props.stateKey);
    }
  );
</script>
<template>
  <a-form-item
    :label-col="props.labelCol"
    :class="`!font-medium custom-input ${labelClass}`"
    :name="props.name"
    :rules="props.rules"
  >
    <template #label>
      <AsteriskText v-if="props.isCompulsory" :label="props.labelText" />
      <p v-else class="text-zinc-600">{{ props.labelText }}</p>
    </template>
    <a-input
      v-model:value="localValue"
      :type="props.type || 'text'"
      :disabled="props.isDisabled"
      :placeholder="props.placeholder"
      :class="`w-[248px] leading-[21px] ${props.inputClass}`"
    />
  </a-form-item>
</template>

<style>
  .custom-input .ant-form-item-label > label {
    line-height: 21px;
  }

  .custom-input .ant-input {
    color: #27272a !important;
    padding: 8px !important;
    line-height: 21px !important;
  }
</style>
